import { useState, useEffect } from 'react';
import { templeApi } from '../api/templeApi';

export const usePoojas = () => {
  const [poojas, setPoojas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPoojas = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await templeApi.getSpecialPoojas();
      
      if (response.data.success) {
        // Transform API data to match your component structure
        const transformedPoojas = response.data.data.articles.map(article => ({
          id: article.aid,
          image: article.assets?.[0]?.asset_value || '', // Get first image
          title: article.article_shortdesc, // Using shortdesc as title
          schedule: article.article_title, // Using title as schedule
          description: article.article_longdesc || '',
        }));
        
        setPoojas(transformedPoojas);
      } else {
        throw new Error('Failed to fetch poojas data');
      }
    } catch (err) {
      console.error('Error fetching poojas:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPoojas();
  }, []);

  return {
    poojas,
    loading,
    error,
    refetch: fetchPoojas,
  };
};